import ChatListPage from '../ChatListPage/ChatListPage'
import './BuyerMessagePage.scss'
import { useEffect } from 'react'

import Navbar from '../../components/CommonComponents/Navbar/Navbar';

const BuyerMessagePage = () => {
  // Prevent body scrolling on mobile - only message content should scroll (includes Galaxy Fold opened)
  useEffect(() => {
    const isMobile = window.innerWidth <= 1023; // Match navbar breakpoint
    
    if (isMobile) {
      // Save current scroll position
      const scrollY = window.scrollY;
      
      // Prevent body scrolling
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollY}px`;
      document.body.style.width = '100%';
      document.body.style.overflow = 'hidden';
      
      // Handle viewport resize (address bar collapse/expand) to prevent content shift
      const handleResize = () => {
        // Ensure wrapper stays fixed during viewport changes
        const wrapper = document.querySelector('.buyerMsgWrapper') as HTMLElement;
        if (wrapper) {
          wrapper.style.position = 'fixed';
          wrapper.style.inset = '0';
        }
      };
      
      window.addEventListener('resize', handleResize);
      window.addEventListener('orientationchange', handleResize);
      
      // Cleanup: restore scrolling when component unmounts
      return () => {
        window.removeEventListener('resize', handleResize);
        window.removeEventListener('orientationchange', handleResize);
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.width = '';
        document.body.style.overflow = '';
        window.scrollTo(0, scrollY);
      };
    }
  }, []);

  return (
    <div className="buyerMsgWrapper">
      <Navbar useScrollVersion={true} />
      <div className="buyerMsgContent">
        <ChatListPage />
      </div>
    </div>
  )
}

export default BuyerMessagePage